export class User {
    idUsuario: string;
    primeiroNome: string;
    senha: string;
    sobrenome: string;
    login: string;
    token: string;
}